import { useEffect } from "react";

/**
 * Subscribe a callback to the global `ens:refresh` event dispatched by the header
 * refresh button. Lets any page do a soft-refetch instead of a full window reload.
 * @param {() => void} fn - callback invoked when refresh is triggered.
 * @param {any[]} deps - dependency list (rebinds handler when deps change).
 */
export function useRefresh(fn, deps = []) {
  useEffect(() => {
    const h = () => { try { fn(); } catch (e) { /* silent */ } };
    window.addEventListener("ens:refresh", h);
    return () => window.removeEventListener("ens:refresh", h);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
